import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Sistema from './views/Sistema'
import Configuracoes from './views/Configuracoes'
import UnidadesNegocio from './views/UnidadesNegocio'
import CadastroUnidadeNegocio from './views/CadastroUnidadeNegocio'
import GestaoVendas from './views/GestaoVendas'
import Regioes from './views/Regioes'
import CadastroRegiao from './views/CadastroRegiao'
import Usuarios from './views/Usuarios'
import Hierarquias from './views/Hierarquias'
import CadastroHierarquia from './views/CadastroHierarquia'
import CadastroPerfil from './views/CadastroPerfil'
import store from './store/store'
import session from './plugins/session'
import range from 'lodash/range'
import Perfis from './views/Perfis'
import Leads from './views/Leads'
import BemVindo from './views/BemVindo'
import NotFound from './views/NotFound'
import Comunicados from './views/Comunicados'
import CadastroComunicado from './views/CadastroComunicado'
import HistoricoLeads from './views/HistoricoLeads'
import DetalheHistoricoLeads from './views/DetalheHistoricoLeads'
import { alert } from './plugins/helpers'
import RemanejamentoLeads from '@/views/RemanejamentoLeads'
import ConfigMesComercial from '@/views/ConfigMesComercial'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login', public: true }
    },
    {
      path: '/logout',
      name: 'logout',
      redirect: (to) => {
        session.destroy()
        return { ...to, name: 'login' }
      }
    },
    {
      path: '/',
      component: Sistema,
      children: [
        {
          path: '/',
          redirect: '/bem-vindo'
        },
        {
          path: '/bem-vindo',
          name: 'bem-vindo',
          component: BemVindo,
          meta: { title: 'Bem-vindo' }
        },
        {
          path: '/hierarquias',
          redirect: '/hierarquias/cadastro',
          name: 'hierarquias',
          component: Hierarquias,
          meta: { title: 'Gestão de Hierarquia', permissao_nome: 'cadastro_hierarquia' }
        },
        {
          path: '/hierarquias/cadastro',
          name: 'cadastro_hierarquia',
          component: CadastroHierarquia,
          meta: { title: 'Cadastro de Hierarquia', permissao_nome: 'cadastro_hierarquia' }
        },
        {
          path: '/usuarios',
          name: 'usuarios',
          component: Usuarios,
          meta: { title: 'Gestão de Usuários', permissao_nome: 'cadastro_usuario' }
        },
        {
          path: '/unidadesnegocio',
          name: 'unidades_negocio',
          component: UnidadesNegocio,
          meta: { title: 'Unidades de Negócio', permissao_nome: 'cadastro_unidades' }
        },
        {
          path: '/relatorio/vendas',
          name: 'gestao_vendas',
          component: GestaoVendas,
          meta: { title: 'Gestão de Vendas', permissao_nome: 'gestao_vendas' }
        },
        {
          path: '/unidadesnegocio/cadastro',
          name: 'cadastro_unidade_negocio',
          component: CadastroUnidadeNegocio,
          meta: { title: 'Cadastro de Unidades de Negócio', permissao_nome: 'cadastro_unidades' }
        },
        {
          path: '/regioes',
          name: 'regioes',
          component: Regioes,
          meta: { title: 'Gestão de Regiões', permissao_nome: 'cadastro_regiao' }
        },
        {
          path: '/regioes/cadastro',
          name: 'cadastro_regiao',
          component: CadastroRegiao,
          meta: { title: 'Cadastro de Região', permissao_nome: 'cadastro_regiao' }
        },
        {
          path: '/configuracoes',
          name: 'configuracoes',
          meta: { title: 'Configurações' }
        },
        {
          path: '/perfis/cadastro',
          name: 'cadastro_perfil',
          component: CadastroPerfil,
          meta: { title: 'Cadastro de Perfis', permissao_nome: 'cadastro_perfil' }
        },
        {
          path: '/perfis',
          name: 'perfis',
          component: Perfis,
          meta: { title: 'Gestão de Perfis', permissao_nome: 'cadastro_perfil' }
        },
        {
          path: '/leads',
          name: 'leads',
          component: Leads,
          meta: { title: 'Distribuição de leads', permissao_nome: 'cadastro_distribuicao_leads' }
        },
        {
          path: '/leads/remanejamento',
          name: 'remanejamento_leads',
          component: RemanejamentoLeads,
          meta: { title: 'Remanejamento de Leads', permissao_nome: 'remanejamento_leads' }
        },
        {
          path: '/comunicados',
          name: 'comunicados',
          component: Comunicados,
          meta: { title: 'Comunicados', permissao_nome: 'cadastro_comunicado' }
        },
        {
          path: '/comunicados/cadastro',
          name: 'cadastro_comunicado',
          component: CadastroComunicado,
          meta: { title: 'Cadastro de Comunicados', permissao_nome: 'cadastro_comunicado' }
        },
        {
          path: '/historico-leads',
          name: 'historico_leads',
          component: HistoricoLeads,
          meta: { title: 'Histórico Leads', permissao_nome: 'historico_leads' }
        },
        {
          path: '/detalhe-historico-leads',
          name: 'detalhe_historico_leads',
          component: DetalheHistoricoLeads,
          meta: { title: 'Timeline', permissao_nome: 'historico_leads' }
        },
        {
          path: '/configuracoes/expiracao-sla',
          name: 'expiracao_sla',
          component: Configuracoes,
          meta: { title: 'Expiração (SLA)', permissao_nome: 'configuracao_expiracao_sla' }
        },
        {
          path: '/configuracoes/mes-comercial',
          name: 'mes_comercial',
          component: ConfigMesComercial,
          meta: { title: 'Mês Comercial', permissao_nome: 'configuracao_mes_comercial' }
        },
        {
          path: '/*',
          name: 'nao-encontrada',
          component: NotFound,
          meta: { title: 'Página não encontrada' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const perfil = session.get('perfil')
  if (checkPerfil(to, perfil)) {
    document.title = to.meta.title || ''
    checkSession(to, next)
  } else {
    alert('Acesso negado!')
    if (from.name === null) {
      router.replace('nao-encontrada')
    }
  }
})

router.afterEach(to => {
  let breadcrumbs = []

  if (to.meta.breadcrumbs) {
    breadcrumbs = to.meta.breadcrumbs
  } else {
    const seg = to.path.split('/').filter(p => !!p)
    const paths = []

    range(seg.length).forEach(() => {
      paths.unshift('/' + seg.join('/'))
      seg.pop()
    })

    breadcrumbs = paths.map(r => router.resolve({ path: r }).route.meta.title)
  }

  store.commit('setBreadcrumbs', breadcrumbs)
})

function checkSession (to, next) {
  if (session.exists()) {
    if (to.name === 'login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else if (!to.meta.public) {
    next({ name: 'login' })
  } else {
    next()
  }
}

function checkPerfil (to, perfil) {
  return (['login', 'nao-encontrada', 'bem-vindo'].indexOf(to.name) !== -1 || !perfil || perfil['permitir_' + to.meta.permissao_nome])
}

export default router
